import React from 'react';
import styled from '@emotion/styled';
import { Field, FieldConfig, FieldProps } from 'formik';

import { COLORS } from '@chronos/constants';

import Select, { Option, SelectProps } from '../Select';
import Text from '../Text';

type FormSelectProps<T extends string | number | object = Option> =
  Pick<FieldConfig, 'children' | 'validate' | 'name'> &
  Omit<SelectProps<T>, 'onSelect'>;

export default function FormSelect<T extends string | number | object = Option>({
  className,
  name,
  validate,
  ...props
}: FormSelectProps<T>) {
  return (
    <div className={className}>
      <Field name={name} validate={validate}>
        {({ field, meta }: FieldProps) => (
          <InputWrapper>
            <Select<T>
              {...field}
              {...props}
              hasError={Boolean(meta.error)}
              onSelect={(value) => field.onChange({ target: {
                value,
                name,
                id: (props.label ?? '__fake__id__').toLowerCase(),
                multiple: false,
                checked: false,
              } })}
            />
            <ErrorMessage>
              <Text semibold color={COLORS.RED}>{meta.error}</Text>
            </ErrorMessage>
          </InputWrapper>
        )}
      </Field>
    </div>
  );
}

const InputWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
});

const ErrorMessage = styled.div({
  padding: 6,
  width: '100%',
});
